module.exports = __webpack_public_path__ + "static/img/qr000.d736ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qr000.png
// module id = JY75
// module chunks = 4